import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiCareerFormSectionDTO,
  CareerFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/careerFormSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class CareerFormSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiCareerFormSectionDTO,
  ): Promise<CareerFormSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new CareerFormSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.successMessage = await parseStrapiContent(strapiData.successMessage);
    return dto;
  }
}
